import { abilitiesPlugin } from "@casl/vue";
import type { App } from "vue";
import { formatPermissions } from "../../utils/formatPermissions";
import { ability } from "./ability";

export default function (app: App) {
  const data = localStorage.getItem("auth");
  if (data) {
    const authData = JSON.parse(data);
    const isGlobal = authData.user?.role?.is_global_admin;
    const abilities = formatPermissions(
      authData.user?.role?.permissions || [],
      isGlobal,
    );
    ability.update(abilities ?? []);
  }

  app.use(abilitiesPlugin, ability, {
    useGlobalProperties: true,
  });
}
